import { useCastle } from "../api/castle";
import { Loading } from "./Loading";
import { ResourceBar } from "../components/ResourceBar";
import { ScreenBanner } from "../components/ScreenBanner";
import { InventoryView } from "../components/InventoryView";

// Top-level "Инвентарь" tab. Wraps the existing InventoryView (which was
// previously a sub-tab inside MeScreen) with banner + resource bar so it
// matches the styling of the other top-level screens.
export function InventoryScreen() {
  const castle = useCastle();
  if (castle.isPending) return <Loading message="Открываю инвентарь..." />;
  const data = castle.data!;
  return (
    <div className="flex h-full flex-col">
      <ScreenBanner kind="profile" title="Инвентарь" />
      <ResourceBar resources={data.state.resources} safeStorage={data.safeStorage} />
      <div className="flex-1 overflow-y-auto">
        <InventoryView enabled />
      </div>
    </div>
  );
}
